import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './OverlappingBookingsView.html?raw';

import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';

import { OverlappingBookingTypes as Types } from "./OverlappingBookingsViewTypes";
import { EvBookingView } from "../../_loadingHelpers/VAMv2";
import TabContainer from '../../../moreCore/UI/Tabbing/TabContainer';
class OverlappingBookingsView extends compose(_WidgetBaseSP) {
	templateString: any = template;

    tableContainer: HTMLDivElement;
    private _jsonData__getDataRequest: Types.JsonData__GetDataRequest;
    private _getDataTimeoutHandle: number;
    private _getDataTimeoutValue: number = 2000;
    private requestHandle: dojo.request.Promise<any> = null;
    private currentData: Types.GetDataResponse;

    setup(data: Types.SearchParameters, delay?: number) {
        this._jsonData__getDataRequest = {
            start: this.dateToLocalISOString(data.start),
            end: this.dateToLocalISOString(data.end),
            roomId: data.roomId,
            selfBookingId: data.selfBookingId,
            isWithRoomList: data.isWithRoomList,
            listRoomId: data.listRoomId
        };

        if (data.start != null
            && data.end != null
            && data.isWithRoomList ? data.listRoomId.length > 0 : data.roomId != null) {

            if (this._getDataTimeoutHandle != null) {
                clearTimeout(this._getDataTimeoutHandle);
            }
            this._getDataTimeoutHandle = setTimeout(lang.hitch(this, this.getData), delay >= 0 ? delay : this._getDataTimeoutValue);
        }
    }


    private getData() {

        if (this._jsonData__getDataRequest == null) {
            return;
        }

        if (this._jsonData__getDataRequest.start == null || this._jsonData__getDataRequest.start == "" ||
            this._jsonData__getDataRequest.end == null || this._jsonData__getDataRequest.end == "") {
            return;
        }

        if (this.requestHandle != null) {
            this.requestHandle.cancel();
            this.requestHandle = null;
        }
        this.StandbyStart();

        var url = window.appRoot + "EvBooking/GetOverlappingBookings";

        /*let jsonData = {
            "end": "2022-08-07 23:00:00",
            "roomId": "0000010f:00000197",
            "start": "2022-08-07 20:00:00"
        };*/

        this.RequestManager.handleAs = "jsonWithDate";
        this.RequestManager.callfunction("Webtool_API_EvBooking__OverlappingBookings_GetList",
            this._jsonData__getDataRequest,
            lang.hitch(this, this._onGetDataResponse),
            lang.hitch(this, this._onGetDataError)
        );
        
        this.emit("dataRequested", this._jsonData__getDataRequest)
    }

    getOverlappingsCount(): number {
        if (this.requestHandle != null) return -1;

        if (!this.currentData) return -1;

        return this.currentData.entityList.length;
    }

    private _onGetDataResponse(response: Types.GetDataResponse) {
        //console.log("_onGetDataResponse", response);
        this.requestHandle = null;
        this.createTable(response);

        this.currentData = response;

        this.emit("dataReceived", response.entityList);
    }

    private _onGetDataError(err: more.requestErrorMessage) {
        this.requestHandle = null;
        alert("ERROR beim _onGetDataError: " + err.Message);
    }

    private createTable(data: Types.GetDataResponse): void {
        this.UiModder.domConstruct.empty(this.tableContainer);
        let table = new StaticTable();

        table.setData(data.entityList);
        table.setTableLayout(data.tableLayouts[0]);
        table.setRowClick(lang.hitch(this, this._showBookingDetails));
        table.setCyAttribute("OverlappingBookingTable");

        this.UiModder.domConstruct.place(table.domNode, this.tableContainer, "first");
        this.StandbyStop();

        this.emit("tableCreated");
    }

    private _showBookingDetails(row: StaticTable.StaticTableRow<any>, data: StaticTable.StaticTableRowGroup<any>) {
        let bookingId = data.entity.ID;

        let tabContainer = this.getTabContainer() as MdsLax<InstanceType<typeof TabContainer>>;
        if (tabContainer) {
            if (tabContainer.activatePageByName(bookingId) == true) return;
        }
        let form = new EvBookingView();

        form.setup(bookingId, null);
        
        form.startup();
    }

    // start DOJO core lifecycle -----------------
    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

    }

    startup(): void {
        super.startup.apply(this, arguments as any);

    }

    destroy(): void {
        super.destroy.apply(this, arguments as any);

        clearTimeout(this._getDataTimeoutHandle);
    }
}

export default mdsWidget(OverlappingBookingsView);